import React, { memo } from 'react';
import { Form, FormItemProps } from 'tea-component';
import './index.scss';

interface TeaFormItemPropsType extends FormItemProps {
  className?: string,
  style?: React.CSSProperties,
  labelName: any,
  isRequired?: boolean,
  children: any,
}

const DEFAULT_PROPS: TeaFormItemPropsType = {
  className: '',
  style: {},
  labelName: '',
  isRequired: false,
  children: null,
};

function TeaFormItem(props: TeaFormItemPropsType) {

  const {
    className,
    style,
    labelName,
    isRequired,
    children,
    ...others
  } = props;

  return (
    <Form.Item
      className={`dbg-common-tea-form-item ${className}`}
      style={style}
      label={labelName}
      required={isRequired}
      {...others}
    >
      {children}
    </Form.Item>
  );

  /* return (
    <Form
      className={`dbg-common-tea-form-item ${className}`}
      style={style}
      layout="fixed"
      fixedLabelWidth={fixedLabelWidth}
    >
    </Form>
  ); */
}

TeaFormItem.defaultProps = DEFAULT_PROPS;

export default memo(TeaFormItem);
